/* eslint-disable no-unused-vars */
import { Space, Table, Tooltip } from "antd";
import React, { useState } from "react";
import { ImCheckmark } from "react-icons/im";
import Select from "react-select";
import CustomDatePicker from "../../../../components/datePickers/CustomDatePicker";
import ConfirmTransactions from "../../../../components/modals/ConfirmTransactions";

function Body({ domainBrand, countries }) {
  const { Column } = Table;
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const menuPortalTarget = document.getElementById("root");

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [pcnValue, setPcnValue] = useState("");
  const [pcnFor, setPcnFor] = useState({});
  // const [filterValue, setFilterValue] = useState("");

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["WO_AWAITING_PAYMENT_-799656216"]
                : "Payment confirmation"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <div className="card overflow-hidden px-3 py-3">
              <div className="form-row">
                <div className="col-lg-6 col-md-6 mb-3">
                  <label>
                    {dictionary
                      ? dictionary[
                          "para_search_the_transactions_here_by_entering..."
                        ]
                      : `
                    Search the transactions here by entering PCN number.`}
                  </label>
                  <input
                    type={"text"}
                    className="form-control"
                    value={pcnValue}
                    onChange={(e) => setPcnValue(e.target.value)}
                  />
                </div>
                <div className="col-lg-6 col-md-6 mb-3">
                  <label>
                    {dictionary
                      ? dictionary["WO_PAYMENT_COLLECTION_F_-2041183868"]
                      : `Payment collection for?`}
                  </label>
                  <Select
                    options={[]}
                    isClearable={false}
                    maxMenuHeight={250}
                    menuPlacement="bottom"
                    menuPortalTarget={menuPortalTarget}
                    value={pcnFor}
                    name="pcnFor"
                    onChange={(option) => {
                      setPcnFor(option);
                    }}
                    className="is-invalid"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <label>From</label>
                  <CustomDatePicker
                    getDate={setFrom}
                    showYearDropdown
                    selectDropdownMode
                    withPortal={true}
                    setMaxDate={new Date()}
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                  <label>To</label>
                  <CustomDatePicker
                    getDate={setTo}
                    showYearDropdown
                    selectDropdownMode
                    withPortal={true}
                    setMaxDate={new Date()}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-lg-6" />
                <div className="col-lg-6 col-md-6">
                  <button
                    className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center"
                    type="button"
                  >
                    {dictionary ? dictionary["l_search"] : "Search"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <Table
                    dataSource={[]}
                    className="w-100 table tbody"
                    loading={false}
                    // rowSelection={rowSelection}
                  >
                    <Column
                      title="Date"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Payment Reference"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Action Type"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Payment Confirmed"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Payment Received"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Amount"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Status"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                    />
                    <Column
                      title="Action"
                      dataIndex="createdDate"
                      key="1"
                      className=""
                      render={(text, record) => {
                        return (
                          <Space size={"small"}>
                            <Tooltip
                              title={"Comfirm Payment"}
                              color="#212529"
                              placement="bottom"
                              arrowPointAtCenter={true}
                            >
                              <ImCheckmark />
                            </Tooltip>
                          </Space>
                        );
                      }}
                    />
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
